import React, { useState } from 'react'
import styles from './scrollTopArrow.module.scss'

const ScrollTopArrow = () => {

    const [showScroll, setShowScroll] = useState(false)

    const checkScrollTop = () => {
        if (!showScroll && window.pageYOffset > 400){
        setShowScroll(true)
        } else if (showScroll && window.pageYOffset <= 400){
        setShowScroll(false)
        }
    };

    const scrollTop = () => {
        window.scrollTo({top: 0, behavior: 'smooth'})
    }

    window.addEventListener('scroll', checkScrollTop)

    return (
        <button className={styles.root} aria-hidden="true" onClick={scrollTop} style={{display: showScroll ? 'flex' : 'none'}}><span className={styles.srOnly}>Scroll to top</span></button>
    )
}

export default ScrollTopArrow
